var map = {
	"./MathBalanceGame.jsx": [
		1249,
		249
	],
	"./MathGame.jsx": [
		5517,
		517
	],
	"./MathGameStub.jsx": [
		873,
		873
	],
	"./MathTowerDefense.jsx": [
		8548,
		548
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9734;
module.exports = webpackAsyncContext;